<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <router-view></router-view>
  </Layout>
</template>

<script>
export default {
  data() {
    return {
      title: "保养请求",
      items: [
        {
          text: "售后服务",
          href: "/",
        },
        {
          text: "保养请求",
          active: true,
          href: "/maintain-request/list",
        },
      ],
    };
  },
  components: {},
};
</script>

<style scoped lang='scss'>
</style>
